export const getInventoryUnitId = unit => unit?._id ?? unit?.ID ?? unit?.id;

export const normalizeInventoryUnit = unit => {
  const unitId = getInventoryUnitId(unit);
  return unitId ? { ...unit, _id: unitId } : null;
};

export const isInventoryUnitExcluded = (unitId, excludedUnitIds = []) =>
  Boolean(unitId) && excludedUnitIds.some(id => id === unitId || String(id) === String(unitId));

export const getInventoryStatus = unit =>
  unit?.contract ? 'Contracted' : unit?.isRSO?.toLowerCase() === 'yes' ? 'RSO' : 'Stock';

export const withInventoryStatus = unit => ({
  ...unit,
  inventoryStatus: getInventoryStatus(unit)
});
